
import SXRemoteSource from "../sxutil/SXRemoteSource";
import SXVideoDelegate from "../sxutil/SXVideoDelegate";
import SXVideoSequence from "../sxutil/SXVideoSequence";


export function CreateTrack(data) {
    let sxTrack = null;
    let { editorManager, duration, currentDrag } = data;
    let SXResource = window["SXResource"], SXResourceType = window["SXResourceType"], Module = window["Module"];
    let textInfoObj = {};
    let groupSource = null;
    let material = null;
    let videoDelegate = null;
   
    switch (data.type) {
        case 1:
            sxTrack = editorManager.createTextTrack(duration);
            sxTrack.setFontFile("/material/font/SourceHanSansCN-Medium.ttf");
            if (data.effectPath) {
                let source = new SXResource(SXResourceType.kTextBubble, data.effectPath);
                sxTrack.setBubble(source);
            }
            sxTrack.setContent("默认文字");
            textInfoObj["content"] = "默认文字";
            sxTrack.setFillColor("#000000");
            textInfoObj["textColor"] = "#000000";
            sxTrack.setFontSize(150);
            textInfoObj["fontSize"] = 60;
            sxTrack.setStrokeWidth(1);
            textInfoObj["strokeWidth"] = 1;
            sxTrack.setTracking(1);
            textInfoObj["wordSpace"] = 1;
            let value = Module.SXTextAlignmentType.kAlignLeft;
            sxTrack.setAlignment(value);
            textInfoObj["align"] = 0;
            break;

        case 2:
            let source1 = new SXResource(SXResourceType.kSticker, data.effectPath);
            sxTrack = editorManager.createStickerTrack(source1, duration);
            break;

        case 5:
            if (currentDrag.file_type == "1") { // 图片
                let source = new SXResource(SXResourceType.kMediaFile, data.effectPath);
                sxTrack = editorManager.createMediaTrack(source, 0);
            } else {
              
                var { videoTrack, delegate } = CreateVideoSequenceTrackWithM3U8Content({ currentDrag, editorManager });
                sxTrack = videoTrack;;
                if (videoTrack) {
                    videoDelegate = delegate;
                    // console.log("create video sequence track: ", videoTrack.getTrackId(), videoTrack.getDuration());
                    groupSource = {
                        trackId: videoTrack.getTrackId(),
                        delegate: delegate,
                    }

                    // 保存记录到 allMaterialList
                    material = {
                        path: delegate.sequenceString,
                        url: currentDrag.mp4_url,
                        type: currentDrag.type_id,
                        category_id: currentDrag.category_id,
                    }

                } else {
                    // delete delegate;
                }
            }

            break;
        case 6:
            let sourceAudio = new SXResource(SXResourceType.kAudioFile, data.effectPath);
            sxTrack = editorManager.createAudioTrack(sourceAudio, 0);
            break;
        default:
            sxTrack = null;
            break;
    }


    return {
        sxTrack, textInfoObj, groupSource, material, videoDelegate
    }

}

// 创建 video sequence media track
export function CreateVideoSequenceTrack(data) {
    let {
        currentDrag, editorManager, mainComposite, isMainTrack
    } = data;

  
    let SXResource = window["SXResource"]

    // @TODO 回调
    function fileLoaded(ret) {
        // console.log("file loaded callback", ret);
    }

    function fileUsed(ret) {
        // console.log("file on used callback", ret);
    }

    // 创建视频序列代理
    function createSXVideoSequenceDelegate(sequences) {
        var options = {
            onFileLoaded: fileLoaded,
            onFileUsed: fileUsed,
        };

        var delegate = new SXVideoDelegate(sequences, options);
        // 注册回调 id
        delegate.setListenerId(window["SXSdk"].registerListener(delegate));
        // 创建 native delegate
        delegate.setNativeDelegate(new window["Module"].SXVideoSequenceDelegate(delegate.getListenerId()));

        return delegate;
    }


    var videoSequence = new SXVideoSequence(
        {
            width: parseInt(currentDrag.video_width),
            height: parseInt(currentDrag.video_height),
            fps: parseFloat(currentDrag.video_fps),
            rotation: 0,
            sample_rate: 44100,
            channels: 2
        });


    return videoSequence.fromM3U8Url(currentDrag.m3u8_url, "/ve-edit/").then(sequences => {
        var delegate = createSXVideoSequenceDelegate(sequences);
        var resource = new SXResource(JSON.stringify(sequences), delegate.getNativeDelegate(), 0);
        var videoTrack = null;
        if (resource && resource.isValid()) {
            if (isMainTrack) { // 主轨道使用 mainComposite 创建
                videoTrack = mainComposite.createMediaTrack(resource, 0);
            } else {
                videoTrack = editorManager.createMediaTrack(resource, 0);
            }
        }
        resource.delete();
        return { videoTrack, delegate };
    });

}


// 创建 video sequence media track
export function CreateVideoSequenceTrackWithM3U8Content(data) {
    let {
        currentDrag, editorManager
    } = data;

  
    let SXResource = window["SXResource"]

    // @TODO 回调
    function fileLoaded(ret) {
        // console.log("file loaded callback", ret);
    }

    function fileUsed(ret) {
        // console.log("file on used callback", ret);
    }

    // 创建视频序列代理
    function createSXVideoSequenceDelegate(sequences) {
        var options = {
            onFileLoaded: fileLoaded,
            onFileUsed: fileUsed,
        };

        var delegate = new SXVideoDelegate(sequences, options);
        // 注册回调 id
        delegate.setListenerId(window["SXSdk"].registerListener(delegate));
        // 创建 native delegate
        delegate.setNativeDelegate(new window["Module"].SXVideoSequenceDelegate(delegate.getListenerId()));

        return delegate;
    }


    var videoSequence = new SXVideoSequence(
        {
            width: parseInt(currentDrag.video_width),
            height: parseInt(currentDrag.video_height),
            fps: parseFloat(currentDrag.video_fps),
            rotation: 0
        });


    var sequences = videoSequence.parseM3U8Content(currentDrag.m3u8_url, currentDrag.m3u8_content, "/ve-edit/")
    var delegate = createSXVideoSequenceDelegate(sequences);
    var resource = new SXResource(JSON.stringify(sequences), delegate.getNativeDelegate(), 0);
    var videoTrack = null;
    if (resource && resource.isValid()) {
        videoTrack = editorManager.createMediaTrack(resource, 0);
        delegate.used();
    }
    resource.delete();
    return { videoTrack, delegate };
}



// 根据 trackId 获取使用的素材代理
export function GetSourceDelegateByTrackId(trackId, sourceList) {
    for (let i = 0; i < sourceList.length; i++) {
        if (sourceList[i].trackId === trackId) {
            return sourceList[i].delegate;
        }
    }
}

// 检查素材是否已经准备好
export function CheckSourceIsReady(data) {
    let { currentTime, trackList, groupList, groupSourceList, sourceList } = data;

    // console.log("groupsourcelist", groupSourceList, groupList);
    let downloadPromise = [];
    let offset = 16;
    let currentCheck = [];

    // 主轨道
    for (let i = 0; i < trackList.length; i++) {
        var trackInfo = trackList[i];
        // 跳过不需要的 track
        var trackStartTime = trackInfo.startTime;
        trackStartTime -= trackInfo.videoTrack.getOffsetTime();
        var trackEndTime = trackInfo.startTime + trackInfo.duration;

        // if (trackStartTime > currentTime || trackEndTime < currentTime) {
        //     continue;
        // }

        var delegate = GetSourceDelegateByTrackId(trackInfo.trackId, sourceList);
        if (!delegate) {
            continue;
        }
        
        // 当前点
        var currentVideos = delegate.getRemoteSourceAt(currentTime - trackStartTime);
        for (let i = 0; i < currentVideos.length; i++) {
            currentCheck.push(currentVideos[i]);
        }

        // 当前范围
        var videos = delegate.getRemoteSourceBetween(currentTime - offset - trackStartTime, currentTime + offset - trackStartTime);

        for (let i = 0; i < videos.length; i++) {
            downloadPromise.push(videos[i].load());
        }
    }

    // console.log("to download", downloadPromise);

    // 其他轨道
    for (let i = 0; i < groupList.length; i++) {
        for (let j = 0; j < groupList[i].trackList.length; j++) {
            var trackInfo = groupList[i].trackList[j];
            // console.log("trackInfo", trackInfo);
            let trackStartTime = trackInfo.startTime;
            trackStartTime -= trackInfo.sxTrack.getOffsetTime();
            let trackEndTime = trackInfo.startTime + trackInfo.duration;

            // console.log("track", currentTime, trackInfo.trackId, trackStartTime, trackEndTime)
            // if (trackStartTime > currentTime || trackEndTime < currentTime) {
            //     continue;
            // }

            var delegate = GetSourceDelegateByTrackId(trackInfo.trackId, groupSourceList);
            if (!delegate) {
                continue;
            }


            // 当前点
            var currentVideos = delegate.getRemoteSourceAt(currentTime - trackStartTime);
            for (let i = 0; i < currentVideos.length; i++) {
                currentCheck.push(currentVideos[i]);
            }

            var videos = delegate.getRemoteSourceBetween(currentTime - trackStartTime, currentTime - trackStartTime + offset);
            for (let i = 0; i < videos.length; i++) {
                downloadPromise.push(videos[i].load());
            }

        }
    }


    // 全部已经准备好

    // 
    return {
        status: currentCheck.length == 0,
        needDownload: downloadPromise.length != 0,
        promise: Promise.all(downloadPromise).then(list => {
            let ret = true;
            for (let i = 0; i < list.length; i++) {
                if (!list[i].isLoaded) {
                    ret = false;
                    break;
                }
            }

            // console.log(" sources loaded: " + list.length)
            return { status: ret };
        })
    };
}
